export const ORGANIZATIONS_QUERY_KEY = ['organizations'] as const;
export const ORGANIZATION_QUERY_KEY = (id: string) => ['organization', id] as const;

interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export type OrganizationsApiResponse<T> = Envelope<T>;

export interface OrganizationListItem {
  id: string;
  name: string;
  city: string;
  companyCity: string;
  geoPoint: { latitude: number; longitude: number } | null;
  code: string;
  webAppUrl: string;
  createdAt: number | null;
  companyName: string;
  companyPhone: string;
  companyEmail: string;
  /** Nazwa hotelu z `hotels/{id}.name` — nie mylić z `hotelId`. */
  hotel: string;
  languages: string[];
  associated_attractions: string[];
  associatedAttractionsCount: number;
  latitude: number;
  longitude: number;
  plan: string | null;
  isTestMode: boolean;
  isDisabled: boolean;
  groupId: string | null;
  test_expiration_date: number | null;
  featuresApp: string[];
  pois: number;
  account_manager: string;
  aiTokenLimit: number | null;
  voiceMonthlyLimits?: unknown;
}

export interface OrganizationDetails extends OrganizationListItem {
  hotelId: string;
}

export interface HotelDetails {
  id: string;
  name: string;
  phone: string;
  email: string;
  address: {
    city: string;
    city_name: string;
    street: string;
    number: string;
    apartmentNumber: string;
    postal_code: string;
    country: string;
    geoPoint: { latitude: number; longitude: number } | null;
  };
  stars: number;
  currency: string;
  brand_url: string;
  cover_photo: string;
  mobileAppAvailable: boolean;
  chatAvailable: boolean;
}

export interface GetOrganizationResult {
  organization: OrganizationDetails;
  hotel: HotelDetails | null;
}

export interface OrganizationWritePayload {
  name: string;
  city: string;
  street: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  postalCode: string;
  country: string;
  latitude: number;
  longitude: number;
  email: string;
  phone?: string;
  domain: string;
  languages: string[];
  baseLang?: string;
  stars?: number;
  currency?: string;
  plan?: string;
  isTestMode?: boolean;
  testExpirationDate?: string | null;
  accountManager?: string;
  aiTokenLimit?: number;
}

/** Stary alias — kolumny tabeli i picker hoteli. */
export type ResponseDataProps = OrganizationListItem;
